export const DIVE_TYPES = {
    sightseeing: 'Sightseeing',
    training: 'Training',
    course: 'Course',
    teaching: 'Teaching',
    clubDive: 'Club dive',
    nightDive: 'Night dive',
    iceDive: 'Ice dive',
    caveDive: 'Cave dive',
    cavernDive: 'Cavern dive',
    wreckDive: 'Wreck dive',
    driftDive: 'Drift dive',
    riverDive: 'River dive',
    exploration: 'Exploration',
    scientificDive: 'Scientific dive',
    commercialDive: 'Commercial dive',
    other: 'Other'
};

export const DIVE_WEATHER = {
    unknown: 'Unknown',
    clear: 'Clear',
    partyCloudy: 'Party cloudy',
    cloudy: 'Cloudy',
    windy: 'Windy',
    rain: 'Rain',
    snow: 'Snow',
    storm: 'Storm'
};

export const DIVE_SALINITY = {
    unknown: 'Unknown',
    seaWater: 'Sea water',
    freshWater: 'Fresh water',
    mixed: 'Mixed'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/DiveEnums.ts